import React from 'react'

const MoveToNextRoundTemplate = ({ data }) => {
  const {
    studentName = '',
    companyName = '',
    currentRound = '',
    nextRound = '',
    signatureName = '',
    signatureRole = '',
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      <p>Hi {studentName},</p>

      <p style={{ paddingTop: '8px' }}>
        This is to inform you that you've been moved to the next {nextRound} round
        at {companyName} after having cleared the {currentRound} round recently.
      </p>

      <p style={{ paddingTop: '8px' }}>
        You will be informed on the next step of the evaluation process shortly.
      </p>

      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>Best regards,</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureName}</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureRole}</p>
    </div>
  )
}

export default MoveToNextRoundTemplate
